import IncludeAllRecommendedToggle from 'components/accessories-page/include-all-recommended-toggle';
import { SelectedSystemType } from 'data/types';
import { useDuctedAccessoriesPageData } from 'hooks/use-ducted-accessories-page-data';
import { useDuctedAccessoriesWriter } from 'hooks/use-ducted-accessories-writer';
import { useMemo } from 'react';
import {
  applyIncludeAllRecommended,
  areAllRecommendedDuctedAccessoriesSelected
} from 'utils/ducted-accessory-selections';

type DuctedIncludeAllRecommendedToggleProps = {
  system: SelectedSystemType;
};

export default function DuctedIncludeAllRecommendedToggle({
  system
}: DuctedIncludeAllRecommendedToggleProps) {
  const { selections, panels, lineSetScopes, isLoading } =
    useDuctedAccessoriesPageData(system);
  const { applySelections } = useDuctedAccessoriesWriter(system);
  const disabled = isLoading;

  const allRecommendedIncluded = useMemo(
    () =>
      areAllRecommendedDuctedAccessoriesSelected({
        selections,
        panels,
        lineSetScopes
      }),
    [selections, panels, lineSetScopes]
  );

  const handleChange = (include: boolean) => {
    if (disabled) return;
    applySelections(
      applyIncludeAllRecommended({
        selections,
        panels,
        lineSetScopes,
        include
      })
    );
  };

  return (
    <IncludeAllRecommendedToggle
      value={allRecommendedIncluded}
      onChange={handleChange}
      disabled={disabled}
    />
  );
}
